module.exports = __webpack_public_path__ + "img/ico-success.2795c20f.svg";